/* import __COLOCATED_TEMPLATE__ from './referral-link.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLElement;
  Args: {
    item: {
      text: string;
      value: string;
      model: string;
    };
  };
}

const ReferralLink = templateOnlyComponent<Signature>();
export default ReferralLink;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::UserMenu::ReferralLink': typeof ReferralLink;
    'inbox2/user-menu/referral-link': typeof ReferralLink;
  }
}
